@use 'sass:map';
@use 'ui/styles/core-tokens' as core;

.pagination {
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;

  &Wrapper {
    align-items: center;
    display: flex;
    justify-content: center;
    gap: 16px;
    margin-bottom: 16px;
  }

  &Controls {
    align-items: center;
    display: flex;
    justify-content: center;
    gap: 8px;
    width: 90%;
  }

  .page {
    &Item {
      align-items: center;
      box-sizing: border-box;
      border: 1px solid #727679;
      border-radius: 2px;
      color: #4d555b;
      cursor: pointer;
      display: flex;
      font-weight: 700;
      justify-content: center;
      height: 28px;
      min-width: 24px;
      padding: 0 1px;
      position: relative;
      width: auto;
    }
  }
}
